import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // States to cache Referral Data
  const [referralData, setReferralData] = useState(null);
  const [isReferralLoading, setIsReferralLoading] = useState(false);

  const fetchUserData = async (newToken = null) => {
    const token = newToken || localStorage.getItem('token');

    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const res = await axios.get(`${API_URL}/api/user/profile`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        setUser(res.data.data || res.data.user); 
      }
    } catch (error) {
      console.error("Context Error:", error.response?.data?.message || error.message);
      // Agar error aaye, toh safayi karo
      localStorage.removeItem('token');
      setUser(null);
      setReferralData(null); // 🔥 Purana referral data saaf
    } finally {
      setLoading(false);
    }
  };

  const fetchReferralData = async () => {
    if (referralData) return;

    setIsReferralLoading(true);
    try {
      const token = localStorage.getItem("token");
      if(!token) return;

      const res = await axios.get(`${API_URL}/api/referrals`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        setReferralData(res.data.data);
      }
    } catch (error) {
      console.error("Referral fetch error:", error.response?.data?.message || error.message);
    } finally {
      setIsReferralLoading(false);
    }
  };

  // 🔥 NEW: Ek proper Logout function jo sab kuch saaf kar dega
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("user");
    
    // Memory saaf karo!
    setUser(null);
    setReferralData(null); 
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    // 🔥 NEW: `logout` aur `setReferralData` ko Provider me export kiya hai
    <UserContext.Provider value={{ 
        user, setUser, loading, fetchUserData, 
        referralData, setReferralData, isReferralLoading, fetchReferralData,
        logout // Ye add kiya
    }}>
      {children}
    </UserContext.Provider>
  );
};